"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var attending_service_1 = require("../../../service/attending.service");
var toast_service_1 = require("../../../../shared/service/toast.service");
var monitoring_step_status_1 = require("../../../constants/monitoring-step-status");
var vehicle_service_1 = require("../../../../diagnosis/service/vehicle.service");
var diagnosis_web_socket_service_1 = require("../../../../diagnosis/service/diagnosis-web-socket.service");
var diagnosis_type_1 = require("../../../../shared/model/diagnosis-type");
var jira_info_service_1 = require("../../../../shared/service/jira-info-service");
var MonitoringConclusionComponent = /** @class */ (function () {
    function MonitoringConclusionComponent(_attendingService, _toastService, _vehicleService, _diagnosisNotification, _JiraIssueInfoService) {
        this._attendingService = _attendingService;
        this._toastService = _toastService;
        this._vehicleService = _vehicleService;
        this._diagnosisNotification = _diagnosisNotification;
        this._JiraIssueInfoService = _JiraIssueInfoService;
        this.getTestResults();
        this.getIssueTypes();
        this.getStorageOn();
        this.getFailureCategories();
    }
    MonitoringConclusionComponent.prototype.ngOnInit = function () {
        this._loading = false;
        this.doDiagnosis = false;
        this.setupObservers();
    };
    Object.defineProperty(MonitoringConclusionComponent.prototype, "attending", {
        get: function () {
            return this._attending;
        },
        set: function (attending) {
            this._attending = attending;
            this.setupEmptyEntities();
            this.findVehicleForDiagnosis();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MonitoringConclusionComponent.prototype, "viewMode", {
        get: function () {
            return this._viewMode;
        },
        set: function (viewMode) {
            this._viewMode = viewMode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MonitoringConclusionComponent.prototype, "authenticatedUser", {
        get: function () {
            return this._authenticatedUser;
        },
        set: function (authenticatedUser) {
            this._authenticatedUser = authenticatedUser;
        },
        enumerable: true,
        configurable: true
    });
    MonitoringConclusionComponent.prototype.setBlockFeatureStatus = function (blockFeatureStatus) {
        this.jiraIssueInfo.blockFeatureStatus = blockFeatureStatus;
    };
    MonitoringConclusionComponent.prototype.setRpmStatus = function (rpmStatus) {
        this.jiraIssueInfo.rpmStatus = rpmStatus;
    };
    MonitoringConclusionComponent.prototype.setViolationSensorStatus = function (violationSensorStatus) {
        this.jiraIssueInfo.violationSensorStatus = violationSensorStatus;
    };
    MonitoringConclusionComponent.prototype.setRfidReaderStatusTX12 = function (rfidReaderStatusTX12) {
        this.jiraIssueInfo.rfidReaderStatusTX12 = rfidReaderStatusTX12;
    };
    MonitoringConclusionComponent.prototype.setCanNetworkStatus = function (canNetworkStatus) {
        this.jiraIssueInfo.canNetworkStatus = canNetworkStatus;
    };
    MonitoringConclusionComponent.prototype.setAccessoriesStatus = function (accessoriesStatus) {
        this.jiraIssueInfo.accessoriesStatus = accessoriesStatus;
    };
    MonitoringConclusionComponent.prototype.setPanicFeatureStatus = function (panicFeatureStatus) {
        this.jiraIssueInfo.panicFeatureStatus = panicFeatureStatus;
    };
    MonitoringConclusionComponent.prototype.setRainSensorStatus = function (rainSensorStatus) {
        this.jiraIssueInfo.rainSensorStatus = rainSensorStatus;
    };
    MonitoringConclusionComponent.prototype.setHodometerStatus = function (hodometerStatus) {
        this.jiraIssueInfo.hodometerStatus = hodometerStatus;
    };
    MonitoringConclusionComponent.prototype.setProvidedService = function (providedService) {
        this.jiraIssueInfo.providedService = providedService;
        this.setFailureCategory(null);
    };
    MonitoringConclusionComponent.prototype.setEquipmentKeeper = function (equipmentKeeper) {
        this.jiraIssueInfo.equipmentKeeper = equipmentKeeper;
    };
    MonitoringConclusionComponent.prototype.setFailureCategory = function (failureCategory) {
        this.getFailureCauses(failureCategory);
        this.jiraIssueInfo.failureCategory = failureCategory;
        this.setFailureCause(null);
    };
    MonitoringConclusionComponent.prototype.setFailureCause = function (failureCause) {
        this.jiraIssueInfo.failureCause = failureCause;
    };
    MonitoringConclusionComponent.prototype.loading = function () {
        return this._loading;
    };
    MonitoringConclusionComponent.prototype.finish = function () {
        var _this = this;
        var finishMonitoring = {
            'attendingId': this._attending.id, 'monitoringId': this._attending.monitoring.id,
            'justification': this.justification, 'jiraIssueInfo': this.jiraIssueInfo
        };
        this._loading = true;
        this._attendingService.finishMonitoring(finishMonitoring)
            .add(function () {
            _this._loading = false;
        });
    };
    MonitoringConclusionComponent.prototype.update = function () {
        var _this = this;
        this._attendingService.setTechnicianScore(this._attending.id, this._attending.technicianScore).subscribe(function (response) {
            _this.showMessage('Nota enviada com sucesso!');
        }, function (error) {
            _this.showMessage(error.text);
        });
    };
    MonitoringConclusionComponent.prototype.canFinish = function () {
        return (((this.getPreviousDiagnosis() !== undefined && !this.getPreviousDiagnosis().approved) ? this.justification != null && this.justification !== '' : true) &&
            this._attending.diagnosisGeneralResults && this._attending.diagnosisGeneralResults.length > 0 || this.doDiagnosis) &&
            this.jiraIssueInfo.observationNeeded != null &&
            this.jiraIssueInfo.equipmentKeeper != null &&
            this.jiraIssueInfo.providedService != null &&
            (this.jiraIssueInfo.providedService === 'Instalação' || this.jiraIssueInfo.failureCause != null);
    };
    MonitoringConclusionComponent.prototype.back = function () {
        this._attending.monitoring.conclusionStep = monitoring_step_status_1.MonitoringStepStatus.NOT_STARTED;
        this._attending.monitoring.validationStep = monitoring_step_status_1.MonitoringStepStatus.CURRENT;
    };
    MonitoringConclusionComponent.prototype.canBack = function () {
        return true;
    };
    MonitoringConclusionComponent.prototype.showEmptyState = function () {
        return !this._attending.diagnosisGeneralResults || this._attending.diagnosisGeneralResults.length === 0 && !this.doDiagnosis;
    };
    MonitoringConclusionComponent.prototype.showRequiredJustification = function () {
        return this.getPreviousDiagnosis() !== undefined && !this.getPreviousDiagnosis().approved;
    };
    MonitoringConclusionComponent.prototype.startDiagnosis = function () {
        this.doDiagnosis = true;
    };
    MonitoringConclusionComponent.prototype.canStartDiagnosis = function () {
        return this.vehicle != null;
    };
    MonitoringConclusionComponent.prototype.hasDiagnosis = function () {
        return this._attending.diagnosisGeneralResults && this._attending.diagnosisGeneralResults.length > 0;
    };
    MonitoringConclusionComponent.prototype.getPreviousDiagnosis = function () {
        if (this.hasDiagnosis()) {
            return this._attending.diagnosisGeneralResults[0];
        }
        return undefined;
    };
    MonitoringConclusionComponent.prototype.findVehicleForDiagnosis = function () {
        if (!this._diagnosisNotification.getCustomer()) {
            this._diagnosisNotification.setCustomer(this.attending.branch.customer);
        }
        if (!this.vehicle) {
            this._vehicleService.getVehiclesByUser(this.attending.branch.customer.trixUser.id, diagnosis_type_1.DiagnosisType.GENERAL);
        }
    };
    MonitoringConclusionComponent.prototype.getTestResults = function () {
        var _this = this;
        this._JiraIssueInfoService
            .getTestResults()
            .subscribe(function (testResults) { return _this.testResults = testResults; }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringConclusionComponent.prototype.getIssueTypes = function () {
        var _this = this;
        this._JiraIssueInfoService
            .getIssueTypes()
            .subscribe(function (issueTypes) { return _this.issueTypes = issueTypes; }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringConclusionComponent.prototype.getStorageOn = function () {
        var _this = this;
        this._JiraIssueInfoService
            .getStorageStatus()
            .subscribe(function (storageOn) { return _this.storageOn = storageOn; }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringConclusionComponent.prototype.getValueOfObservationNeeded = function () {
        if (this.jiraIssueInfo.observationNeeded) {
            return "Sim";
        }
        return "Não";
    };
    MonitoringConclusionComponent.prototype.getFailureCategories = function () {
        var _this = this;
        this._JiraIssueInfoService
            .getFailureCategory()
            .subscribe(function (failureCategories) { return _this.failureCategories = failureCategories; }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringConclusionComponent.prototype.getFailureCauses = function (failureCategory) {
        var _this = this;
        this._JiraIssueInfoService
            .getFailureCauseByCategory(failureCategory)
            .subscribe(function (failureCauses) { return _this.failureCauses = failureCauses; }, function (error) { return _this.showMessage(error.text); });
    };
    MonitoringConclusionComponent.prototype.hasCause = function () {
        return this.jiraIssueInfo.failureCategory != null && this.jiraIssueInfo.failureCategory != "N/A";
    };
    MonitoringConclusionComponent.prototype.needFailureCategory = function () {
        return this.jiraIssueInfo.providedService === "Reinstalação" || this.jiraIssueInfo.providedService === "Manutenção" ||
            this.jiraIssueInfo.providedService === "Auditoria";
    };
    MonitoringConclusionComponent.prototype.setupObservers = function () {
        var _this = this;
        this._vehicleService.find$
            .subscribe(function (vehicles) {
            _this.vehicle = vehicles.find(function (vehicle) { return vehicle.plate === _this._attending.vehiclePlate; });
            if (_this.vehicle !== undefined) {
                _this.vehicle.attendingId = _this._attending.id;
                _this.vehicle.diagnosisType = diagnosis_type_1.DiagnosisType.GENERAL;
                _this.vehicle.coordinateStartDate = _this._attending.attendingInfo.startedDate;
            }
        });
    };
    MonitoringConclusionComponent.prototype.showMessage = function (message) {
        this._toastService.showMessage(message, 4000);
    };
    MonitoringConclusionComponent.prototype.setupEmptyEntities = function () {
        if (this._attending.monitoring.approvalJustification && this._attending.monitoring.approvalJustification !== "") {
            this.justification = this._attending.monitoring.approvalJustification;
        }
        if (this._attending.monitoring.jiraIssueInfo) {
            this.jiraIssueInfo = this._attending.monitoring.jiraIssueInfo;
        }
        if (this.jiraIssueInfo.observationNeeded) {
            this.observationNeeded = this.getValueOfObservationNeeded();
        }
    };
    MonitoringConclusionComponent.ctorParameters = function () { return [{ type: attending_service_1.AttendingService }, { type: toast_service_1.ToastService }, { type: vehicle_service_1.VehicleService }, { type: diagnosis_web_socket_service_1.DiagnosisWebSocketService }, { type: jira_info_service_1.JiraIssueInfoService }]; };
    return MonitoringConclusionComponent;
}());
exports.MonitoringConclusionComponent = MonitoringConclusionComponent;
//# sourceMappingURL=monitoring-conclusion.component.js.map


// WEBPACK FOOTER //
// monitoring-conclusion.component.js